import * as React from 'react';
import { BaSeSmall2, BaSeTheme } from '@base/react';
import { Badge } from '../certificados-cliente-styled';

export const StatusBadge = ({ ativo }) => {
  const { sucesso26, erro45 } = BaSeTheme.colors.feedbackInterface;
  const color = ativo ? sucesso26 : erro45;
  const text = ativo ? 'Ativo' : 'Inativo';

  return (
    <Badge ativo={ativo}>
      <BaSeSmall2 isBold color={color}>
        {text}
      </BaSeSmall2>
    </Badge>
  );
};
